const type = {
  NEW_PASSWORD: "NEW_PASSWORD",
};
export default type;
